<template>
  <div class="my-20 flex flex-col items-center">
    <div v-if="currentPage && totalCount">
      <slot>
        <SFButton :to="prevPage" @click.prevent="loadMore">
          {{ $t('pagination.load_previous') }}
        </SFButton>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from '#app/composables/router'
import { SFButton } from '#storefront-ui/components'
import { useHead } from '#imports'

// Destructure the props into local variables
const { totalCount, pageToLoad } = defineProps<{
  totalCount?: number
  pageToLoad?: number
}>()

const route = useRoute()
const router = useRouter()

const currentPage = computed(() => Number(route.query.page || 1))

const prevPage = computed(() => ({
  query: {
    ...route.query,
    page: pageToLoad ?? currentPage.value - 1,
  },
}))

const loadMore = async () => {
  await router.push(prevPage.value)
}

if (currentPage.value >= 2) {
  useHead({
    meta: [{ name: 'robots', content: 'noindex, follow' }],
  })
}
</script>
